export default {
    REQUIRED_OPTION_EMPTY_MESSAGE: "Поле не заполнено",
    REQUIRED_BOOL_OPTION_EMPTY_MESSAGE: "Пусто"
};
